import {
    GET_LIST_ANGGOTA,
    GET_LIST_ANGGOTA_SUCCESS,
    GET_LIST_ANGGOTA_FAIL,
  } from "./actionTypes";
  import { API } from "../../API/api";
  
  // get exco table
  export const getDaftarAnggota = (order_type,order_by,page,size,search,id_tingkat_exco,id_daerah,jenis_kelamin,status_perkawinan) => (dispatch) => {
    dispatch({
      type: GET_LIST_ANGGOTA,
    });
  
    const request = API.getDaftarAnggota(order_type,order_by,page,size,search,id_tingkat_exco,id_daerah,jenis_kelamin,status_perkawinan);
    return request.then(
      (response) => dispatch(getDaftarAnggotaSuccess(response.data)),
      (err) => dispatch(getDaftarAnggotaFail(err))
    );
  };
  
  export const getDaftarAnggotaSuccess = (data) => (dispatch) => {
    return dispatch({
      type: GET_LIST_ANGGOTA_SUCCESS,
      payload: data,
    });
  };

  export const getDaftarAnggotaFail = (data) => (dispatch) => {
    return dispatch({
      type: GET_LIST_ANGGOTA_FAIL,
      payload: data,
    });
  };

  